
import { computed, defineComponent } from "vue";
import { useStore } from "vuex";
import styleUtils from '@/utils/style';
import GenericPanel from "../shared/GenericPanel.vue";
import GenericSubPanel from "../shared/GenericSubPanel.vue";

export default defineComponent({
    name: "Pool",
    setup() {
        const store = useStore();
        const charPoints = computed(() => store.state.build.SPECIAL.PL.value);
        const successClass = computed(() => styleUtils.calculateSuccessClass(charPoints.value, 10, true));
        const showInfo = (category: string, stat: string) => {
            store.dispatch('handleIncomingCommand', {
                command: 'updateInfoPanel',
                data: { category, stat }
            });
        };
        return {
            state: store.state,
            showInfo,
            charPoints,
            successClass
        };
    },
    components: { GenericPanel, GenericSubPanel }
});
